import { isServer } from "@tanstack/react-query";
import FathomTracker from "./fathom";
import { Tracker } from "./types";
import UmamiTracker from "./umami";

const dataAttributeName = "data-tracking-event";
const propAttributePrefix = `${dataAttributeName}-`;

export const umami = new UmamiTracker();
umami.init();

export const fathom = new FathomTracker();
fathom.init();

const trackers: Tracker[] = [umami, fathom];

const readProps = (element: Element): Record<string, string> => {
  const props: Record<string, string> = {};

  for (const attribute of Array.from(element.attributes)) {
    if (attribute.name.startsWith(propAttributePrefix)) {
      props[attribute.name.slice(propAttributePrefix.length)] = attribute.value;
    }
  }

  return props;
};

export const initTracking = () => {
  if (isServer) {
    return;
  }

  window.document.body.addEventListener("click", (event) => {
    let element = event.target;

    // Only the innermost tagged ancestor fires. Climbing past it would count a tagged button
    // inside a tagged card twice.
    while (element instanceof Element) {
      const eventName = element.getAttribute(dataAttributeName);

      if (eventName) {
        trackEvent(eventName, readProps(element));
        return;
      }

      element = element.parentElement;
    }
  });
};

export const isTrackingEnabled = () => {
  return trackers.every((tracker) => tracker.isEnabled());
};

export const trackEvent = (
  eventName: string,
  props?: Record<string, string | number | boolean | undefined>,
) => {
  trackers.forEach((tracker) => {
    try {
      tracker.trackEvent(eventName, props);
    } catch {
      // Tracking must never break the action the user actually took.
    }
  });
};

export const disableTracking = () => {
  trackers.forEach((tracker) => tracker.disable());
};
